<script lang="ts">
    import { getScriptUrl, onPrivacyManagerApiLoaded } from '$lib/services/trustArc';
    import {
        TRUSTARC_LOAD_RETRIES,
        TRUSTARC_LOAD_RETRY_INTERVAL
    } from '$lib/services/trustArc/constants';
    import { onMount } from 'svelte';
    import { page } from '$app/stores';

    export let implied = false;
    export let privacypolicylink = '';

    $: ({ market } = $page.data);

    const TRUSTARC_LATENCY = 2000;
    let retryAttempt: number = 0;
    let loadRetryTimer: ReturnType<typeof setTimeout> | null;
    let privacyManagerApiUnload = () => {};
    export let trustArcScriptLoaded: boolean = false;

    const onScriptLoadedCallback = () => {
        trustArcScriptLoaded = true;
    };

    const onLoad = () => {
        // This is necessary because PrivacyManagerAPI is not available at the time of trustarc onLoad event.
        setTimeout(handlePrivacyManager, TRUSTARC_LATENCY);
    };

    const handlePrivacyManager = () => {
        if (window.PrivacyManagerAPI) {
            privacyManagerApiUnload = onPrivacyManagerApiLoaded(onScriptLoadedCallback);
        } else {
            trustArcScriptLoaded = true;
        }
    };

    const loadScript = () => {
        let scriptPath = getScriptUrl(implied, market.slug, privacypolicylink, retryAttempt);
        const script = document.createElement('script');
        script.src = scriptPath;
        script.crossOrigin = '';
        script.defer = true;
        script.onload = onLoad;
        script.onerror = () => {
            document.head.removeChild(script);
            if (loadRetryTimer) {
                clearTimeout(loadRetryTimer);
            }

            if (retryAttempt < TRUSTARC_LOAD_RETRIES) {
                console.warn(
                    `Error loading ${scriptPath} script. Retrying ${retryAttempt + 1}/${TRUSTARC_LOAD_RETRIES}`
                );
                loadRetryTimer = setTimeout(() => {
                    retryAttempt = retryAttempt + 1;
                    scriptPath = getScriptUrl(
                        implied,
                        market.slug,
                        privacypolicylink,
                        retryAttempt
                    );
                    loadScript();
                }, TRUSTARC_LOAD_RETRY_INTERVAL);
            } else {
                console.error(`Error loading ${scriptPath} script. All retries failed`);
            }
        };
        document.head.appendChild(script);
    };

    const onConsentSettingsRequestHandler = () => {
        if (window.truste?.eu) {
            window.truste.eu.clickListener();
        }
    };

    onMount(() => {
        if (window.self !== window.parent) {
            return;
        }
        window.addEventListener('cookie-consent-settings:show', onConsentSettingsRequestHandler);

        loadScript();

        return () => {
            window.removeEventListener(
                'cookie-consent-settings:show',
                onConsentSettingsRequestHandler
            );
            privacyManagerApiUnload();
        };
    });
</script>

<div id="consent_blackbar" class="c-module-cookie-consent-trustarc"></div>

<style>
    :global(.truste-track) {
        z-index: 65 !important;
    }
</style>
